export default __webpack_public_path__ + "static/media/map.3a73fb97.jpg";